module.exports = __webpack_public_path__ + "img/live.a27f74b0.png";